export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function emailToUsername(email: string): string {
  const local = normalizeEmail(email).split('@')[0] ?? email;
  return local.replace(/\./g, '_');
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
